import { TextField } from '@mui/material';
import { Box } from '@mui/system';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../shared/redux/store';

const RequestConfiguration = () => {
  const request = useSelector((state: RootState) => state?.requestSearch?.searchRequest?.equivalencies);
  return (
    <Box sx={{ display: 'flex', gap: '1rem', flexGrow: 1 }}>
      <Box className="EQXXI-RequestDetail-DataBox EQXXI-RequestDetail-PlanDetail" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <TextField
          fullWidth
          className="EQXXI-RequestDetail-InstitutionName opacity-disable"
          variant="standard"
          label={t('sourceInstitution') as string}
          data-testid={'institutionsSource-input'}
          disabled
          value={request?.syllabus?.institution?.name ?? '-'}
        />
        <TextField
          fullWidth
          className="EQXXI-RequestDetail-SyllabusName opacity-disable"
          variant="standard"
          label={t('sourceSyllabus') as string}
          data-testid={'syllabusSource-input'}
          disabled
          value={request?.syllabus?.name ?? '-'}
        />
      </Box>
      <Box className="EQXXI-RequestDetail-DataBox EQXXI-RequestDetail-PlanDetail" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <TextField
          fullWidth
          className="EQXXI-RequestDetail-InstitutionName opacity-disable"
          variant="standard"
          label={t('stargetInstitution') as string}
          data-testid={'institutionTarget-input'}
          disabled
          value={request?.target_syllabus?.institution?.name ?? ''}
        />
        <TextField
          fullWidth
          className="EQXXI-RequestDetail-SyllabusName opacity-disable"
          variant="standard"
          label={t('targetSyllabus') as string}
          data-testid={'syllabusTarget-input'}
          disabled
          value={request?.target_syllabus?.name ?? ''}
        />
      </Box>
    </Box>
  );
};

export default RequestConfiguration;
